import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Loader,
  LoadingOverlay,
  Menu,
  Select,
  SelectProps,
  Text,
  TextInput,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import {
  IconBrandBootstrap,
  IconCalendar,
  IconCaretDown,
  IconCheck,
  IconEdit,
  IconEye,
  IconFileExport,
  IconFileUpload,
  IconLocationFilled,
  IconPlus,
  IconSearch,
  IconSettingsCheck,
  IconSettingsX,
  IconPrinter,
  IconStatusChange,
  IconX,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";

import { DatePickerInput } from "@mantine/dates";
import {
  _timerDelayClick,
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../_base/_const/_constVar";
import { paginationBase } from "../../_base/model/_base/BaseTable";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../common/FormatDate/FormatDate";
import { _localization } from "../../config/location";
import { MessageResponse } from "../../model/MessageResponse";
import { TblDMExpense } from "../../model/TblDMExpense";
import {
  getBranchSelectMdm,
  getTblDmEmployeeSelect,
  getTblDmProcessingMethodSelect,
  getProvinceSelectNew,
  getCommuneSelectNew,
} from "../../service/getSelectApi";

import { useDebouncedState, useDisclosure } from "@mantine/hooks";
import { IconTransferIn } from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router-dom";
import _breadcrumb from "../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { AvatarUtils } from "../../common/ColorByName/AvatarUtils";
import { BASE_API_MDM } from "../../config";
import { cobalt_blue, green } from "../../const/variables";
import { CreateInWardWarranty } from "../../model/CreateInWardWarranty";
import CreateReceiptForm from "./CreateServiceRepairForm";
import DetailProductWarranty from "./ServiceRepairProductDetail";
import UpdateServiceRepairForm from "./UpdateServiceRepairForm";
import EditReceiptForm from "./EditServiceRepairForm";
import PrinterReceiveTicket from "./PrinterServiceRepair";
import { useReactToPrint } from "react-to-print";


type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const ServiceRepairList = () => {
  //#region State
  //data and fetching state
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblDMExpense[]>([]);
  const [dataTemp, setDataTemp] = useState<TblDMExpense[]>([]);
  const [isError, setIsError] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [idEdit, setIdEdit] = useState(0);
  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  // const [keySearch, setKeySearch] = useState<string>("");
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const [dataTblDmEmployee, setDataTblDmEmployee] = useState<any>();
  const [callApi, setCallApi] = useState(false);
  const [isKTKT, setIsKTKT] = useState(false);
  const [dataTblDmRequestStatus, setDataTblDmRequestStatus] = useState<{
    isLoad: boolean;
    data: any[];
  }>({
    isLoad: false,
    data: [],
  });
  const [dataTblProcessingMethod, setDataTblProcessingMethod] = useState<{
    isLoad: boolean;
    data: any[];
  }>({
    isLoad: false,
    data: [],
  });
  const [dataSubmitInWard, setDataSubmitInWard] =
    useState<CreateInWardWarranty>({
      sourceId: 0,
      tblItemTransactionHeaderCommand: {
        transactionId: null,
        transactionCode: null,
        transactionDate: new Date()?.toISOString(),
        subSourceId: null,
        sourceCode: null,
        sourceType: null,
        branchId: null,
        subInvId: null,
        departmentId: null,
        status: null,
        description: null,
        atribute1: null,
        atribute2: null,
        atribute3: null,
        atribute4: null,
        atribute5: null,
        atribute6: null,
        atribute7: null,
        atribute8: null,
        atribute9: null,
        atribute10: null,
        createBy:
          JSON.parse(localStorage.getItem("userLogin") || "{}")?.id || "",
        createDate: new Date().toISOString(),
        lastUpdateDate: null,
        lastUpdateBy: null,
        type: null,
        finishDate: null,
      },
      serials: [
        {
          primaryQuantity: 0,
          subQuantity: 0,
          serial: null,
          invId: 0,
          serialStatus: null,
          seritalNote: null,
          itemCode: null,
          locationId: 0,
        },
      ],
      isLock: true,
    });
  const [dataTblBranch, setDataTblBranch] = useState<any>();
  const [branchAllValue, setBranchAllValue] = useState<any>();
  // Search
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const [search, setSearch] = useState<any>({
    requestNum: _searchJson && checkedPinSearch ? _searchJson?.requestNum : "",
    startDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.startDate
        : new Date(
            new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
              7 * 60 * 60 * 1000,
          )?.toISOString(),
    endDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.endDate
        : new Date(
            new Date(
              new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
                0,
                0,
                0,
                0,
              ),
            ).getTime() +
              7 * 60 * 60 * 1000,
          )?.toISOString(),
    status: _searchJson && checkedPinSearch ? _searchJson?.status : "",
    itemStatus: _searchJson && checkedPinSearch ? _searchJson?.itemStatus : "",
    processingMethod:
      _searchJson && checkedPinSearch ? _searchJson?.processingMethod : "",
    branch: _searchJson && checkedPinSearch ? _searchJson?.branch : "",
  });

  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );

  const [serialSearch, setSerialSearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.serialSearch : "",
    300,
  );

  //viewState
  const [actionView, setActionView] = useState("");

  //#region  table
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [

      {
        accessorKey: "transactionCode",
        header: "Số phiếu nhập kho",
        Cell: ({ renderedCellValue }) => renderedCellValue ? (
          <Badge
            radius="sm"
            variant="outline"
            color="blue"
          >
            {renderedCellValue}
          </Badge>
        ) : null,
        enableColumnActions: true,
        enableColumnFilter: false,
        enableSorting: false,
      },

      {
        accessorKey: "branchName",
        header: "Chi nhánh",
        enableColumnActions: true,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "createDate",
        header: "Ngày tạo phiếu",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        enableColumnActions: true,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "errorNumber",
        header: "Số phiếu tiếp nhận hàng lỗi",
        Cell: ({ renderedCellValue, row }) => renderedCellValue ? (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="outline"
              color="blue"
              onDoubleClick={() => detailItem(row.original.id)}
            >
              {renderedCellValue}
            </Badge>
          </Tooltip>
        ) : null,
        enableColumnActions: true,
        enableColumnFilter: false,
        enableSorting: false,
        size: 200,
      },
      {
        accessorKey: "createByName",
        header: "Người tiếp nhận",
        Cell: ({ row }: any) => (
          <>{row.original.createByName}</>
        ),
        enableSorting: false,
        enableColumnActions: true,
        enableColumnFilter: false,
        size: 225,
      },
      {
        accessorKey: "custMeeting",
        header: "Khách hàng hẹn gặp",
        enableColumnActions: true,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "custPhone",
        header: "Số điện thoại",
        enableColumnActions: true,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "meetingAddress",
        header: "Địa chỉ hẹn gặp",
        enableColumnActions: true,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {[row.original.meetingAddress, row.original.communeName, row.original.provinceName]
              .filter((i) => i && String(i).length > 0)
              .join(" - ")}
          </Text>
        ),
        size: 550,
      },
      {
        accessorKey: "attribute6",
        header: "Trạng thái phiếu",
        Cell: ({ renderedCellValue }) => (
            <Badge
              color={
                renderedCellValue === "DA_NHAP"
                  ? "green"
                  : renderedCellValue === "DA_TRA_KHACH"
                    ? "teal"
                    : renderedCellValue === "TRA_MOT_PHAN"
                      ? "orange"
                      : renderedCellValue === "TAO_MOI"
                        ? "gray"
                        : "blue"
              }
              variant="outline"
              radius={"sm"}
            >
              {renderedCellValue === "DA_NHAP"
                ? "Đã nhập kho"
                : renderedCellValue === "DA_TRA_KHACH"
                  ? "Đã trả khách"
                  : renderedCellValue === "TRA_MOT_PHAN"
                    ? "Trả một phần"
                    : renderedCellValue === "TAO_MOI"
                      ? "Tạo mới"
                      : "Đã tiếp nhận"}
            </Badge>
        ),
        enableColumnActions: true,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: true,
        enableColumnFilter: false,
        enableResizing: false,
        size: 130,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >

            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                color="yellow"
                onClick={async () => await editItem(row.original.id)}
                disabled={row.original.attribute6 !== "TAO_MOI"}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xem chi tiết">
              <ActionIcon
                variant="light"
                color="cyan"
                onClick={async () => await detailItem(row.original.id)}
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [],
  );

  function getColorProcessingMethod(value: string) {
    switch (value) {
      case "Xử lý tại nhà":
        return "lime";
      case "Hãng xử lý":
        return "green";
      case "Xử lý trực tiếp":
        return "teal";
      case "Xử lý tại CH/CN":
        return "cyan";
      case "Xử lý từ xa":
        return "orange";
      case "":
      case null:
        return "rgba(255, 255, 255, 0)";
    }
  }

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const getAllRequestStatus = async () => {
    const url = "api/v1/TblDmRequestStatus/get-all";
    const callapi = await repositoryMdm.get<MessageResponse<any[]>>(url);
    if (callapi?.success) return callapi?.data;
    return [];
  };

  const dataRequestStatusSelect = async () => {
    try {
      const getData = await getAllRequestStatus();
      const filteredData = getData?.filter(
        (item) => item.code != null && item.name != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.code.toString(),
        label: item.name.toString(),
      }));
      setDataTblDmRequestStatus((prev) => ({
        ...prev,
        data: mappedData,
      }));
    } catch (error) {
      console.error("Error in dataDeliveryStatusSelect: ", error);
    }
  };

  const dataEmployeeSelect = async () => {
    try {
      const getData = await getTblDmEmployeeSelect();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblDmEmployee(
        new Map(mappedData.map((item) => [item.value, item.label])),
      );
    } catch (error) {
      console.error("Error in dataDeliveryStatusSelect: ", error);
    }
  };

  const dataBranchSelect = async () => {
    const getData = await getBranchSelectMdm();
    setBranchAllValue(getData);
    setDataTblBranch(
      getData
        ?.filter(
          (item: any) =>
            item.value != null &&
            item.text != null &&
            item.value != "-1" &&
            // Dịch vụ sửa chữa chỉ làm việc với chi nhánh pháp nhân DVT (attr6 = CompanyCode)
            item.attr6 === "DVT",
        )
        ?.map((item: any) => ({
          value: item.value,
          // Hiển thị "Mã CN - Tên CN" (att2 = mã chi nhánh)
          label: item.att2 ? `${item.att2} - ${item.text}` : item.text,
        })),
    );
  };

  const dataProcessingMethodSelect = async () => {
    try {
      const getData = await getTblDmProcessingMethodSelect();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.text,
        label: item.text,
      }));
      setDataTblProcessingMethod((prev) => ({
        ...prev,
        data: mappedData,
      }));
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const handleChangeSearchValue = (value: string, key: string) => {
    setSearch((prevData: any) => ({ ...prevData, [key]: value }));
  };

  //#region In phiếu tiếp nhận
  // Dùng lại template và cách chuẩn bị dữ liệu của màn chi tiết để phiếu in không bị lệch.
  const printRef = React.useRef(null);
  const [dataPrint, setDataPrint] = useState<any>(null);
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    pageStyle: `@page { size:auto; margin: 5mm 0; }`,
  });

  const preparePrintData = async (id: string | number) => {
    open();
    try {
      const res = await repositoryMdm.get<MessageResponse<any>>(
        `/api/v1/ServiceRepair/detail-service-repair?id=${id}`,
      );
      if (!res?.success || !res.data) {
        NotificationExtension.Fails("Không lấy được thông tin phiếu để in !");
        return;
      }

      const detailData = { ...res.data };

      if (detailData.provinceId) {
        const provinces = await getProvinceSelectNew();
        const prov = provinces?.find(
          (p: any) => Number(p.id) === Number(detailData.provinceId),
        );
        if (prov) detailData.provinceName = prov.name;

        const communes = await getCommuneSelectNew(String(detailData.provinceId));
        const comm = communes?.find(
          (c: any) => Number(c.value) === Number(detailData.communeId),
        );
        if (comm) detailData.communeName = comm.text;
      }

      const branchRes = await repositoryDelivery.get<MessageResponse<any>>(
        `/api/v1/TblDmMasterOrg/get-all`,
      );
      const branch = branchRes?.success
        ? branchRes.data?.find(
            (item: any) => Number(item.id) === Number(detailData.branchId),
          )
        : null;

      setDataPrint({
        ...detailData,
        addressBranch: branch?.address ?? "",
        nameBranch: branch?.name ?? "",
        companyCode: branch?.companyCode ?? "",
      });
    } finally {
      close();
    }
  };

  // Chỉ gọi in sau khi component in đã render xong với dữ liệu mới
  useEffect(() => {
    if (dataPrint) handlePrint();
  }, [dataPrint]);
  //#endregion

  const navigateKTKT = async (id: number | string) => {
    const res = await repositoryDelivery.post<MessageResponse<any>>(
      "/api/v1/TblTestingTechniqueHeader/create-from-transaction",
      { transactionId: id },
    );

    if (res && res?.success) {
      setIsKTKT(false);
    }
  };

  const handleInWardWarranty = async () => {
    console.log("dataSubmitInWard", dataSubmitInWard);
    const res = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/Inward/create-in-ward-warranty",
      dataSubmitInWard,
    );

    if (res && res?.success) {
      if (isKTKT) {
        navigateKTKT(res?.data);
      }
      setTimeout(() => {
        setDeleteViewStatus(!deleteViewStatus);
      }, 1500);
      NotificationExtension.Success("Nhập kho thành công !");
    }
  };

  // Thông báo lưu thành công của màn tạo/sửa. Không bật ngay tại màn đó vì khi quay ra đây,
  // mỗi request của HttpHelper lại gọi notifications.clean() nên toast bị xoá liên tục.
  // Giữ lại rồi bật sau khi fetchData() chạy xong toàn bộ chuỗi request.
  const pendingSuccessRef = React.useRef<string | null>(null);

  const fetchData = async () => {
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.startDate) {
      url += `&StartDate=${search.startDate}`;
    }

    if (search.endDate) {
      url += `&EndDate=${search.endDate}`;
    }

    if (keySearch) {
      url += `&KeySearch=${keySearch.trim()}`;
    }

    if (serialSearch) {
      url += `&Serial=${serialSearch.trim()}`;
    }

    if (search.status) {
      url += `&RequestStatus=${search.status}`;
    }

    if (search.itemStatus) {
      url += `&ItemStatus=${search.itemStatus}`;
    }

    if (search.processingMethod) {
      url += `&ProcessingMethod=${search.processingMethod}`;
    }

    if (search.branch) {
      url += `&BranchId=${search.branch}`;
    }

    try {
      const response = await repositoryMdm.get(
        `/api/v1/ServiceRepair/get-list${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        await Promise.all([dataEmployeeSelect(), dataBranchSelect()]);

        // Resolve tên tỉnh/xã cho danh sách
        try {
          const provinces = await getProvinceSelectNew();
          const provinceMap = new Map(provinces?.map((p: any) => [String(p.id), p.name]) || []);
          const provinceIds = [...new Set(result?.map((r: any) => r.provinceId).filter(Boolean))];
          let communeMap = new Map();
          for (const pid of provinceIds) {
            const communes = await getCommuneSelectNew(String(pid));
            communes?.forEach((c: any) => communeMap.set(String(c.value), c.text));
          }
          result = result?.map((r: any) => ({
            ...r,
            provinceName: provinceMap.get(String(r.provinceId)) || "",
            communeName: communeMap.get(String(r.communeId)) || "",
          }));
        } catch (e) {
          console.error("Resolve province/commune error:", e);
        }

        setData(result);
        setDataTemp(result);
        setRowCount(response.totalCount);
        setSelectIds([]);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    }
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
          serialSearch: serialSearch,
        }),
      );
    startCountdown();

    // Mọi request của lượt nạp đã xong nên không còn notifications.clean() nào xoá mất
    if (pendingSuccessRef.current) {
      NotificationExtension.Success(pendingSuccessRef.current);
      pendingSuccessRef.current = null;
    }
  };

  const handleExportData = async () => {
    open();
    try {
      let url = `/api/v1/TblWarrantyReceiveTicket/export-tbl-warranty-receive-ticket?Skip=${
        pagination?.pageIndex * pagination?.pageSize
      }&Take=${pagination.pageSize}`;

      if (search.startDate) {
        url += `&StartDate=${search.startDate}`;
      }

      if (search.endDate) {
        url += `&EndDate=${search.endDate}`;
      }

      if (keySearch) {
        url += `&KeySearch=${keySearch.trim()}`;
      }

      if (serialSearch) {
        url += `&Serial=${serialSearch.trim()}`;
      }

      if (search.status) {
        url += `&RequestStatus=${search.status}`;
      }

      if (search.itemStatus) {
        url += `&ItemStatus=${search.itemStatus}`;
      }

      if (search.processingMethod) {
        url += `&ProcessingMethod=${search.processingMethod}`;
      }

      if (search.branch) {
        url += `&BranchId=${search.branch}`;
      }

      const _url = BASE_API_MDM + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "danh_muc_phieu_tiep_nhan_hang_loi_dv" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        NotificationExtension.Success("Export Excel thành công !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const ActionViews = React.useCallback(() => {
    switch (actionView) {
      case "CREATE":
        return (
          <Box h={window.innerHeight - 180}>
            <CreateReceiptForm
              onClose={setActionView}
              onSuccess={setDeleteViewStatus}
              onSaved={(msg: string) => (pendingSuccessRef.current = msg)}
            />
          </Box>
        );
      case "EDIT":
        return (
          <Box h={window.innerHeight - 180}>
            <UpdateServiceRepairForm
              id={idEdit}
              onClose={setActionView}
              onSuccess={setDeleteViewStatus}
              onSaved={(msg: string) => (pendingSuccessRef.current = msg)}
            />
          </Box>
        );
      default:
        return null;
    }
  }, [actionView]);

  const createItem = React.useCallback(() => {
    setActionView("CREATE");
  }, []);

  const editItem = React.useCallback((id: string | number) => {
    setActionView("EDIT");
    setIdEdit(Number(id));
  }, []);

  const detailItem = React.useCallback(
    (id: string | number) => {
      navigate("/service-repair/detail-receive-ticket", {
        state: { id: Number(id) },
      });
    },
    [navigate],
  );

  const optionColorsAccount: Record<
    | "Xử lý tại nhà"
    | "Hãng xử lý"
    | "Xử lý tại chỗ"
    | "Xử lý tại CH/CN"
    | "Xử lý từ xa",
    string
  > = {
    "Xử lý tại nhà": "lime",
    "Hãng xử lý": "green",
    "Xử lý tại chỗ": "teal",
    "Xử lý tại CH/CN": "cyan",
    "Xử lý từ xa": "orange",
  };

  const renderSelectOptionStatus: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorsAccount[
            option.label as
              | "Xử lý tại nhà"
              | "Hãng xử lý"
              | "Xử lý tại chỗ"
              | "Xử lý tại CH/CN"
              | "Xử lý từ xa"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const colorsItemStatus: Record<
    "Đã tiếp nhận" | "Đã nhập kho" | "Trả một phần" | "Đã trả khách",
    string
  > = {
    "Đã tiếp nhận": "blue",
    "Đã nhập kho": "green",
    "Trả một phần": "orange",
    "Đã trả khách": "teal",
  };

  const renderSelectOptionItemStatus: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          colorsItemStatus[
            option.label as
              | "Đã tiếp nhận"
              | "Đã nhập kho"
              | "Trả một phần"
              | "Đã trả khách"
          ]
        }
        radius="sm"
        variant="outline"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchData();
  }, [deleteViewStatus, pagination]);

  useEffect(() => {
    if (
      dataTblDmRequestStatus.isLoad &&
      dataTblDmRequestStatus.data?.length === 0
    )
      dataRequestStatusSelect();
  }, [dataTblDmRequestStatus.isLoad]);

  useEffect(() => {
    dataProcessingMethodSelect();
  }, []);

  useEffect(() => {
    if (callApi) {
      handleInWardWarranty();
      setCallApi(false);
    }
  }, [callApi]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (170 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, [height]);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningServiceRepairList",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["mrt-row-select", "errorNumber"],
          right: ["attribute6", "action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );

  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningServiceRepairList",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderDetailPanel: ({ row }) => (
      <DetailProductWarranty
        dataDetail={row.original.tblWarrantyReceiveTicketDetailModels}
      />
    ),
    enableExpandAll: false,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },

    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      // columnFilters,
      // globalFilter,
      pagination,
      showAlertBanner: isError,
      //sorting,
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });
  //#endregion
  return (
    <>
      {(!actionView.isNullOrEmpty() && <ActionViews />) || (
        <>
          <div
            ref={headerRef}
            style={{ border: "1px solid #dee2e6", padding: "10px" }}
          >
            <LoadingOverlay
              visible={visible}
              zIndex={1000}
              overlayProps={{ radius: "sm", blur: 5 }}
              loaderProps={{
                children: (
                  <Flex direction={"column"} align="center" gap="xs">
                    <Loader type="dots" size={35}></Loader>
                    {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                    <Title size={15}> Đang xử lý....</Title>
                  </Flex>
                ),
              }}
            />
            <Flex
              w={"100%"}
              justify={"space-between"}
              wrap={"wrap"}
              align={"center"}
            >
              <_breadcrumb></_breadcrumb>
              <Flex
                gap="md"
                justify="flex-end"
                align="center"
                direction="row"
                wrap="wrap"
              >
                <Button
                  leftSection={<IconPlus size={14} />}
                  color="blue"
                  variant="outline"
                  onClick={async () => {
                    createItem();
                  }}
                >
                  Thêm mới
                </Button>
                <Menu shadow="md" width={200}>
                  <Menu.Target>
                    <Button
                      // size="xs"
                      rightSection={
                        <IconCaretDown
                          style={{ width: rem(14), height: rem(14) }}
                        />
                      }
                    >
                      Chức năng
                    </Button>
                  </Menu.Target>

                  <Menu.Dropdown>
                    <Menu.Item
                      leftSection={
                        <IconFileExport
                          style={{ width: rem(14), height: rem(14) }}
                        />
                      }
                      onClick={() => handleExportData()}
                    >
                      Export Excel
                    </Menu.Item>
                    <Tooltip label={"Chức năng đang update"}>
                      <Menu.Item
                        leftSection={
                          <IconFileUpload
                            style={{ width: rem(14), height: rem(14) }}
                          />
                        }
                      >
                        Import Excel
                      </Menu.Item>
                    </Tooltip>
                    <Menu.Item
                      leftSection={
                        <IconEye style={{ width: rem(14), height: rem(14) }} />
                      }
                      onClick={() => detailItem(selectIds[0])}
                      disabled={selectIds.length !== 1}
                    >
                      Xem chi tiết
                    </Menu.Item>
                    <Menu.Item
                      leftSection={
                        <IconPrinter style={{ width: rem(14), height: rem(14) }} />
                      }
                      onClick={() => preparePrintData(selectIds[0])}
                      disabled={selectIds.length !== 1}
                    >
                      In phiếu tiếp nhận
                    </Menu.Item>

                    <Menu.Item
                      leftSection={
                        <IconX style={{ width: rem(14), height: rem(14) }} />
                      }
                    >
                      Đóng
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              </Flex>
            </Flex>
            <Grid w={"100%"} mt={10}>
              <Grid.Col span={{ base: 12, md: 4, lg: 1.5 }}>
                <DatePickerInput
                  size="sm"
                  placeholder="Từ ngày"
                  leftSection={
                    <IconCalendar
                      size={20}
                      style={{ color: cobalt_blue.base }}
                    />
                  }
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  value={
                    search.startDate && search.startDate.length > 0
                      ? new Date(search.startDate)
                      : null
                  }
                  maxDate={
                    search.endDate && search.endDate?.length > 0
                      ? new Date(search.endDate)
                      : new Date()
                  }
                  onChange={(e) => {
                    handleChangeSearchValue(
                      formatDateNotTimeZone(e) ?? "",
                      "startDate",
                    );
                  }}
                  clearable
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 4, lg: 1.5 }}>
                <DatePickerInput
                  size="sm"
                  placeholder="Đến ngày"
                  leftSection={
                    <IconCalendar
                      size={20}
                      style={{ color: cobalt_blue.base }}
                    />
                  }
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  value={
                    search.endDate && search.endDate.length > 0
                      ? new Date(search.endDate)
                      : null
                  }
                  minDate={
                    search.startDate && search.startDate?.length > 0
                      ? new Date(search.startDate)
                      : undefined
                  }
                  onChange={(e) => {
                    handleChangeSearchValue(
                      formatDateNotTimeZone(e) ?? "",
                      "endDate",
                    );
                  }}
                  clearable
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 4, lg: 1.5 }}>
                <Select
                  placeholder="Chi nhánh"
                  searchable
                  clearable
                  value={search.branch || null}
                  leftSection={
                    <IconBrandBootstrap
                      size={20}
                      style={{ color: cobalt_blue.base }}
                    />
                  }
                  data={dataTblBranch}
                  onChange={(e) =>
                    handleChangeSearchValue(e?.toString() ?? "", "branch")
                  }
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 4, lg: 1.5 }}>
                <Select
                  placeholder="Hình thức xử lý"
                  type="text"
                  w={"100%"}
                  clearable
                  searchable
                  leftSection={
                    <IconLocationFilled
                      size={20}
                      style={{ color: cobalt_blue.base }}
                    ></IconLocationFilled>
                  }
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  value={search.processingMethod || null}
                  data={dataTblProcessingMethod.data}
                  onChange={(e) => {
                    handleChangeSearchValue(
                      e?.toString() ?? "",
                      "processingMethod",
                    );
                  }}
                  renderOption={renderSelectOptionStatus}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 4, lg: 1.5 }}>
                <Select
                  placeholder="Trạng thái phiếu"
                  data={[
                    { label: "Đã tiếp nhận", value: "DA_TIEP_NHAN" },
                    { label: "Đã nhập kho", value: "DA_NHAP" },
                    { label: "Trả một phần", value: "TRA_MOT_PHAN" },
                    { label: "Đã trả khách", value: "DA_TRA_KHACH" },
                  ]}
                  leftSection={
                    <IconStatusChange
                      size={20}
                      style={{ color: cobalt_blue.base }}
                    />
                  }
                  value={search.itemStatus || null}
                  onChange={(e) =>
                    handleChangeSearchValue(e?.toString() ?? "", "itemStatus")
                  }
                  renderOption={renderSelectOptionItemStatus}
                />
              </Grid.Col>

              <Grid.Col span={{ base: 12, md: 4, lg: 1.5 }}>
                <TextInput
                  placeholder="Nhập Serial/Imei"
                  type="text"
                  w={"100%"}
                  defaultValue={serialSearch}
                  leftSection={
                    <IconSearch
                      size={20}
                      style={{ color: cobalt_blue.base }}
                    ></IconSearch>
                  }
                  onChange={(e) => {
                    setSerialSearch(e.target.value ?? "");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      fetchData();
                    }
                  }}
                />
              </Grid.Col>

              <Grid.Col span={{ base: 12, md: 4, lg: 1.5 }}>
                <TextInput
                  placeholder="Từ khóa tìm kiếm"
                  type="text"
                  w={"100%"}
                  defaultValue={keySearch}
                  leftSection={
                    <IconSearch
                      size={20}
                      style={{ color: cobalt_blue.base }}
                    ></IconSearch>
                  }
                  onChange={(e) => {
                    setKeySearch(e.target.value ?? "");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      fetchData();
                    }
                  }}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 4, lg: 1.5 }}>
                <Button
                  leftSection={<IconSearch size={14} />}
                  color="blue"
                  variant="outline"
                  onClick={() => {
                    fetchData();
                  }}
                >
                  Tìm kiếm
                </Button>
              </Grid.Col>
            </Grid>
          </div>
          <div>
            <MantineReactTable table={table} />
          </div>

          {/* Phiếu in — luôn nằm ngoài luồng hiển thị */}
          {dataPrint && (
            <Box display="none">
              <PrinterReceiveTicket
                innerRef={printRef}
                dataPrint={dataPrint}
                dataPYCXL={{
                  custMeeting: dataPrint.custMeeting,
                  custPhone: dataPrint.custPhone,
                  additionalAddress: dataPrint.additionalAddress,
                  meetingAddress: dataPrint.meetingAddress,
                  processingMethodName: dataPrint.processingMethodName,
                  channelName: dataPrint.channelName,
                  requestNum: dataPrint.requestNum,
                }}
              />
            </Box>
          )}
        </>
      )}
    </>
  );
};
export default ServiceRepairList;
